module.exports = __webpack_public_path__ + "static/media/egle.097a2404.jpg";